module.exports = __webpack_public_path__ + "img/gift.62790c24.svg";